import compose from 'lodash/fp/compose';
import React from 'react';

import ListContacts from '../../contacts/ListContacts';
import { withDocumentTitle } from '../../generic/DocumentTitle';
import ScopedDrawer, { changelog, comments } from '../../generic/ScopedDrawer';
import ListCategorizedInvoices from '../../invoices/ListCategorizedInvoices';
import Titled from '../../layout/Titled';
import ListCategorizedOpportunities from '../../opportunities/ListCategorizedOpportunities';
import { zmsAMMerchantShape } from '../../prop-types';
import api from '../../REST/api';
import AuthorizedLink from '../../REST/AuthorizedLink';
import withResolved from '../../REST/with-resolved';
import MerchantForm from '../MerchantForm';
import { getTransformedMerchant } from '../transform-merchant-helpers';

const ShowMerchant = ({ model }) => {
  const context = { contentType: 'zms_am_merchant', objectId: model.id };
  return (
    <Titled
      title={model.name}
      actions={[
        <AuthorizedLink
          to="edit"
          className="btn btn-secondary ml-2"
          query={api.patchOpportunity}
        >
          Edit
        </AuthorizedLink>,
      ]}
      sticky
    >
      <ScopedDrawer options={[comments(context), changelog(context)]}>
        <div className="mb-4">
          <MerchantForm model={model} />
        </div>
        <div className="mb-5">
          <ListCategorizedOpportunities
            merchantIds={model.id}
            hiddenColumns={['Self Service Merchant']}
            titleSize="sm"
            showCreateLink={false}
          />
        </div>
        <div className="mb-4">
          <ListContacts
            search={{ merchantId: model.id }}
            titleSize="sm"
            showAddContactButton={false}
            showUploadButton={false}
          />
        </div>
        <div className="mb-4">
          <ListCategorizedInvoices
            titleSize="sm"
            merchantIds={[model.id]}
            hiddenColumns={['Merchants']}
          />
        </div>
      </ScopedDrawer>
    </Titled>
  );
};

ShowMerchant.propTypes = {
  model: zmsAMMerchantShape.isRequired,
};

export default compose(
  withResolved({
    query: getTransformedMerchant,
    deriveQueryArgs: props => ({ id: props.match.params.id }),
    as: 'model',
  }),
  withDocumentTitle(({ model }) => model.name),
)(ShowMerchant);
